import { render, staticRenderFns } from "./ImageUploadConfig.vue?vue&type=template&id=218d06fe&scoped=true"
import script from "./ImageUploadConfig.vue?vue&type=script&lang=js"
export * from "./ImageUploadConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218d06fe",
  null
  
)

export default component.exports